import React, { Component } from "react"
import Page, { Grid, GridColumn } from "@atlaskit/page"
import Moment from "moment-timezone"

class DateSignature extends Component {
  render() {
    console.log("render DateSignature")
    return (
      <div
        style={{
          textAlign: "center",
          pageBreakInside: "avoid",
          margin: "40px"
        }}
      >
        <div style={{ marginTop: "10em" }}>
          <Page>
            <Grid>
              <GridColumn medium={3}>
                <div style={{ fontSize: "20px", textAlign: "right" }}>
                  {Moment().format("DD.MM.YYYY")}
                </div>
              </GridColumn>
            </Grid>
            <div style={{ width: "100%", borderBottom: "1px solid #d0d0d0" }} />
            <Grid>
              <GridColumn medium={3}>
                <div
                  style={{
                    fontSize: "10px",
                    textAlign: "right"
                  }}
                >
                  Datum
                </div>
              </GridColumn>
              <GridColumn medium={9}>
                <div
                  style={{
                    fontSize: "10px",
                    textAlign: "right"
                  }}
                >
                  Unterschrift
                </div>
              </GridColumn>
            </Grid>
          </Page>
        </div>
      </div>
    )
  }
}

export default DateSignature



// WEBPACK FOOTER //
// ./src/components/DateSignature.jsx